import { render, staticRenderFns } from "./loadingPage.vue?vue&type=template&id=403d67d0&scoped=true"
import script from "./loadingPage.vue?vue&type=script&lang=js"
export * from "./loadingPage.vue?vue&type=script&lang=js"
import style0 from "./loadingPage.vue?vue&type=style&index=0&id=403d67d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403d67d0",
  null
  
)

export default component.exports